import type { AppState } from '../types';
import { saveLocal, loadLocal } from './localCache';

let offline = false;
export function setOfflineMode(on: boolean) { offline = on; }
export function isOffline(): boolean { return offline; }

export class ConflictError extends Error {
  serverState: AppState;
  constructor(serverState: AppState) {
    super('state conflict');
    this.name = 'ConflictError';
    this.serverState = serverState;
  }
}

export async function fetchState(slug: string): Promise<AppState | null> {
  if (offline) return loadLocal(slug);
  const r = await fetch(`/api/state?slug=${encodeURIComponent(slug)}`);
  if (r.status === 404) return null;
  if (!r.ok) throw new Error(`fetchState ${r.status}`);
  return await r.json() as AppState;
}

export async function putState(
  slug: string, next: AppState, ifMatch: string | null,
): Promise<AppState> {
  if (offline) { saveLocal(slug, next); return next; }
  const r = await fetch(`/api/state?slug=${encodeURIComponent(slug)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...(ifMatch ? { 'If-Match': ifMatch } : {}) },
    body: JSON.stringify(next),
  });
  if (r.status === 409) throw new ConflictError(await r.json() as AppState);
  if (!r.ok) throw new Error(`putState ${r.status}`);
  return await r.json() as AppState;
}
